import styled from 'styled-components'
import App from '../../../../static/images/resources/gray/icon-website.svg'
import Video from '../../../../static/images/resources/gray/icon-video.svg'
import Audio from '../../../../static/images/resources/gray/icon-audio.svg'
import Image from '../../../../static/images/resources/gray/icon-image.svg'
import Document from '../../../../static/images/resources/gray/icon-document.svg'
import Presentation from '../../../../static/images/resources/gray/icon-presentation.svg'
import Simulation from '../../../../static/images/resources/gray/icon-simulation.svg'
import Web from '../../../../static/images/resources/gray/icon-website.svg'

const IconComponent = styled.div`
  background: #fff;
`

export const AppIcon = styled(IconComponent)`
  height: 39px;
  width: 40px;
  mask: url(${App}) no-repeat;
`

export const VideoIcon = styled(IconComponent)`
  height: 36px;
  width: 40px;
  mask: url(${Video}) no-repeat;
`

export const AudioIcon = styled(IconComponent)`
  height: 37px;
  width: 38px;
  mask: url(${Audio}) no-repeat;
`

export const ImageIcon = styled(IconComponent)`
  height: 37px;
  width: 38px;
  mask: url(${Image}) no-repeat;
`

export const DocumentIcon = styled(IconComponent)`
  height: 38px;
  width: 34px;
  mask: url(${Document}) no-repeat;
`

export const PresentationIcon = styled(IconComponent)`
  height: 34px;
  width: 39px;
  mask: url(${Presentation}) no-repeat;
`

export const SimulationIcon = styled(IconComponent)`
  height: 38px;
  width: 38px;
  mask: url(${Simulation}) no-repeat;
`

export const WebIcon = styled(IconComponent)`
  height: 39px;
  width: 40px;
  mask: url(${Web}) no-repeat;
`



// WEBPACK FOOTER //
// ./src/components/quest/activity/resources/_Styled.js